export const AMENITY_CONSTANTS = {
  DEFAULT_AMENITY_COUNT: 0,
  DEFAULT_AMENITY_MANDATORY_COUNT: 0,
  DEFAULT_COUNT: 1,
  DEFAULT_PRICE: 0,
  DEFAULT_PRICE_INFO: {
    isVatInclusive: true,
    price: 0,
    vat: "0",
  },
  DEFAULT_SELECTED_AMENITY: 0,
  DEFAULT_VAT: "0",
  DEFAULT_VAT_PERCENTAGE_VALUE: 0,
  DEFAULT_VAT_VALUE: 0,
  IS_VAT_EXCLUSIVE: false,
  IS_VAT_INCLUSIVE: true,
  OPEN_ACCORDION: "1",
  PER_AMENITY: 1,
  VAT_INCLUSIVE: "INCLUSIVE",
};
